export interface IActiveTermsCultureFull {
  id: number;
  ProviderId: number,
  description: string;
  details: string,
  culture: string;
  cultureDisplayName: string;
  markdown: string,
  termsId: number
}
